export const colors = {
  dark: "#000000",
};

export const colorScheme = {
  primary: colors.dark,
  secondary: colors.dark,
  text: colors.dark,
};
